module.exports = __webpack_public_path__ + "img/tomatogreen.71dd59a6.png";